<script lang="ts" setup>
import { HantecIcon } from '@hantecmarket/hantec-ui-widget'
import { nextTick, onMounted } from 'vue'

import PaymentMethodLogos from '@/components/Footer/PaymentMethodLogos.vue'
import { useFooterData } from '@/services/seoGlobalService'

const footerMidaData = useFooterData()

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: HTMLElement | null, refresh: boolean) => void
    }
  }
}

const loadTrustpilot = () => {
  if (window.Trustpilot) {
    window.Trustpilot.loadFromElement(document.getElementById('trustpilot-widget'), true)
  } else {
    console.warn('Trustpilot script is not yet loaded.')
  }
}

onMounted(() => {
  nextTick(() => {
    loadTrustpilot()
  })
})
</script>

<template>
  <div
    class="flex flex-col lg:px-5 items-center justify-center gap-10 lg:gap-[50px] border-gray-500 lg:border-y 1440:py-[66px] lg:flex-row lg:justify-center 1440:gap-40 px-[10px] 1440:px-0 lg:py-10"
  >
    <div class="block w-full lg:hidden border-t-3 border-gray-350 md:hidden"></div>

    <div
      class="flex flex-col justify-center gap-10 1440:w-full 1440:gap-0 1440:items-center 1440:flex-row lg:justify-center 1440:justify-between lg:max-w-1200"
    >
      <div
        class="w-full flex flex-col text-center lg:text-start lg:max-w-[440px] 1440:max-w-[340px] 1440:block"
      >
        <p
          v-html="footerMidaData.paymentsectionitle"
          class="self-start ml-0 mr-auto leading-normal lg:text-xl 1440:text-2xl md:whitespace-nowrap"
        ></p>

        <div
          class="flex flex-col md:flex-row justify-center lg:gap-6 gap-[15px] whitespace-nowrap lg:justify-normal items-center lg:mt-0 mt-[44px]"
        >
          <p
            :key="index"
            v-for="(subtitle, index) in footerMidaData.paymentsectiontexts"
            class="flex lg:flex-row flec-col lg:gap-2.5 gap-[5px] items-center text-[17px] leading-[28px]"
          >
            <HantecIcon width="16"></HantecIcon>
            {{ subtitle.text }}
          </p>
        </div>
      </div>

      <PaymentMethodLogos></PaymentMethodLogos>
    </div>
    <div class="self-center block w-full lg:hidden border-t-3 border-gray-350"></div>
    <div class="flex flex-col">
      <img
        class="hidden lg:block w-[186px] h-[116px] 1440:my-0 1440:hidden ml-[15px] self-start mb-10"
        :src="footerMidaData?.sponsor_logo"
      />
    </div>
    <div
      id="trustpilot-widget"
      class="self-start hidden trustpilot-widget lg:block 1440:hidden"
      data-businessunit-id="5f78343dacf3dd0001936c20"
      data-locale="en"
      data-review-languages="en"
      data-style-height="100%"
      data-style-width="214px"
      data-template-id="5613c9cde69ddc09340c6beb"
      data-theme="dark"
    >
      <a href="https://uk.trustpilot.com/review/hmarkets.com/" rel="noopener" target="_blank"
        >Trustpilot</a
      >
    </div>
  </div>
</template>
